const resourceHeaders = [
  {
    key: 'id',
    text: 'ID',
    type: 'CHECKBOX',
    dataType: 'number'
  },
  {
    key: 'name',
    text: 'Nome',
    type: 'DEFAULT',
    dataType: 'text'
  },
  {
    key: 'path',
    text: 'Caminho do servidor',
    type: 'DEFAULT',
    dataType: 'text',
    props: { th: { className: 'large-col' } }
  },
  {
    key: 'category',
    text: 'Tipo',
    type: 'DEFAULT',
    dataType: 'text'
  },
  {
    key: 'createdAt',
    text: 'Dt. Criação',
    type: 'DEFAULT',
    dataType: 'date'
  },
  {
    key: 'updatedAt',
    text: 'Dt. Atuali.',
    type: 'DEFAULT',
    dataType: 'date'
  },
];

export default resourceHeaders;
